module.exports = __webpack_public_path__ + "static/img/3.319e072.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3.jpg
// module id = iCB0
// module chunks = 2